import { useState } from 'react';
import AppBar from '@mui/material/AppBar';
import { useLocation, Link } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";

import MDBoxRoot from "./MDBox/MDBoxRoot";
import MDTypographyRoot from './MDTypography/MDTypographyRoot';
import MDButtonRoot from "./MDButton/MDButtonRoot";
import MDDrawerRoot from "./MDDrawer/MDdrawer";
import Breadcrumbs from './BreaadCrumbs/Breadcrumbs';

import setThemeObj from './../hooks/useThemeMUI';
import RightSideProfile from './RightSideProfile';
import SvgImg from '../imges/Kayack-person-icon.svg';

export default function DashbordTop({wthT}) {
    const [isModalProfOpen, setIsModalProfOpen] = useState(false);
    const route = useLocation().pathname.split("/").slice(1);  
    
    const handleClickOpen = () => {
        setIsModalProfOpen(true);
      };
    return (     
<ThemeProvider theme={setThemeObj}>
<AppBar
position="fixed" color='transparent'
sx={{ width:`calc(98% - ${wthT}px)`, top:"2px", marginRight: '10px'}} >
<MDBoxRoot 
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexDirection="row"
    ownerState={{     
        variant: "gradient", 
        color:"white", 
        opacity: 1,
        bgColor: "info", 
        borderRadius: "lg", 
        shadow: "xs",
        coloredShadow: "info" }} 
        width="98%"
       pb={1} mx={2} mt={3} >
 <MDBoxRoot 
        display="flex"
        justifyContent="space-between"
        alignItems="baseline"
        flexDirection="column">   
 <MDTypographyRoot  ownerState={{ 
  color:"white",
  textDecoration:"none",
  textTransform:"none",
  verticalAlign:"unset",
  fontWeight:undefined,
  opacity:1,
  textGradient:false,
  darkMode:false,
  marginTop:2,
  marginLeft:5,
  marginRight:0,
  marginBottom:2,
  GradientStyles:{
    backgroundImage: "...",
    display: "inline-block",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "...",
    position: "relative",
    zIndex: 1,
  } }} sx={{ display: 'flex', width: '100%',justifyContent: 'space-between '}}>
    Scheduling dashboard
  </MDTypographyRoot>
    <Breadcrumbs   theme={setThemeObj} title={route[route.length - 1]} route={route} />
  </MDBoxRoot>
  <MDButtonRoot
        ownerState={{
          size: "small",
          variant: "outlined",
          color: "info",
          textTransform:"none",
          circular: false,
          iconOnly: false,
          darkMode:false
        }} sx={{ textTransform: 'none' }} 
        onClick={handleClickOpen} >
    <img src={SvgImg} width='40px' height='40px'/>
  </MDButtonRoot>

  {isModalProfOpen && (<>
            <RightSideProfile onClose={() => setIsModalProfOpen(false) } />   
       </> )}

  </MDBoxRoot>
</AppBar>
</ThemeProvider>
    )
}
